import { createContext, useContext } from "react";

export const OrcaCommonContext = createContext({
  initDuration: 0,
  initializeNewVideo: () => {}
});

export const useOrcaCommonContext = () => useContext(OrcaCommonContext);
